import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check if we're in browser environment
        const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';
        
        // For SSR: Allow access (server can't check localStorage)
        // Client-side auth check will happen after hydration
        if (!isBrowser) {
            return true;
        }
        
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.backToLogin(state);
        return false;
    }

    private  backToLogin (state: RouterStateSnapshot) {
        this.router.navigate(['/signin'], { queryParams: { returnUrl: state.url } });
    }
}
